import { Outlet } from 'react-router-dom'
import { AuthDialog } from './AuthDialog'
import { Logo } from './Logo'
import { SiteHeader } from './SiteHeader'

export function AppLayout() {
  return <>
    <div className="app-shell">
      <SiteHeader />
      <main><Outlet /></main>
      <footer className="site-footer"><Logo/><span>MiXer AI 开发者平台 v2.1 · Build, ship and evaluate Agents.</span></footer>
    </div>
    <AuthDialog />
  </>
}
